/* tslint:disable */
/* eslint-disable */
/**
 * BFF Web Product
 * API reference used to call the backend from the web frontend
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetResourcesByCohortIdsRequest
 */
export interface GetResourcesByCohortIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetResourcesByCohortIdsRequest
     */
    'cohortIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetResourcesByCohortIdsRequest
     */
    'type': GetResourcesByCohortIdsRequestTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GetResourcesByCohortIdsRequestTypeEnum {
    SECTION = 'SECTION',
    GROUP = 'GROUP',
    EXTERNAL_MEMBER_AREA = 'EXTERNAL_MEMBER_AREA'
}


